export default {
    PTE_FIRMA: 0,
    EMITIDA: 1,
    ANULADA: 2
}
